import React from 'react';

import GeneralOpportunityForm from './GeneralOpportunityForm';

import LoadingSpinner from 'CommonComponents/LoadingSpinner';
import Modal from 'CommonComponents/Modal';
import ModalHeader from 'CommonComponents/ModalHeader';

export default function GeneralOpportunityUpsertModal({
    id,
    modal,
    opportunity,
    isLoading,
    storeUrl,
    updateUrl,
    departmentsOptions,
    fetchBudgetLinesUrl,
    onClose,
    onCreated,
}) {
    const close = () => {
        onClose();
        modal.hide();
    };

    const handleCreated = () => {
        close();
        onCreated();
    };

    return (
        <Modal id={id} modal={modal} parentContainerClasses="modal__container-large">
            <ModalHeader title={opportunity ? $t('Edit {{name}}', { name: opportunity.name }) : $t('Add New Opportunity')} close={close}></ModalHeader>
            <div className="tw-rounded-b">
                {isLoading ? (
                    <LoadingSpinner />
                ) : (
                    <div className="modal__form-container">
                        <GeneralOpportunityForm
                            storeUrl={storeUrl}
                            updateUrl={updateUrl}
                            opportunity={opportunity}
                            departmentsOptions={departmentsOptions}
                            fetchBudgetLinesUrl={fetchBudgetLinesUrl}
                            onSuccess={handleCreated}
                            onCancel={close}
                        />
                    </div>
                )}
            </div>
        </Modal>
    );
}
